/**
 * `<ConnectionsRuntime />` (`D281`, `D282`): what runs for the connections
 * whatever screen is showing — each finished workout written to Health
 * Connect and posted to Strava, each only when switched on. Mounted once by
 * the shell beside `<WorkoutRuntime />`. Renders nothing; the Health Connect
 * half starts only in a shell that carries its plugin.
 */
import { useEffect } from "react";
import { useApi } from "../../data/api";
import { healthConnectInShell } from "../../native";
import { startHealthExport } from "./health-row";
import { startStravaExport } from "./strava-row";

export function ConnectionsRuntime(): null {
  const api = useApi();
  useEffect(
    () => (healthConnectInShell() ? startHealthExport() : undefined),
    []
  );
  useEffect(() => startStravaExport(api), [api]);
  return null;
}
